
import { Vue, Component, PropSync } from 'nuxt-property-decorator'
import { Prop } from 'vue-property-decorator'

export enum StepDialogType {
  FULL = 'full',
  BOTTOM = 'bottom',
  BOTTOM_AUTO = 'bottom-auto',
}

@Component
export default class BottomSheet extends Vue {
  @PropSync('show', { required: true, default: false, type: Boolean })
  isShow!: boolean

  @Prop({
    type: String,
    default: '',
  })
  private readonly componentTitle: string | undefined

  @Prop({
    type: Boolean,
    default: true,
  })
  private readonly isClosed: boolean | undefined

  @Prop({
    type: Boolean,
    default: true,
  })
  private readonly isGoBack: boolean | undefined

  @Prop({
    type: String,
    default: StepDialogType.FULL,
  })
  private readonly type: StepDialogType | undefined

  private handlerCloseClick () {
    this.isShow = false
    this.$emit('close')
  }

  private handlerBackClick () {
    this.$emit('back')
  }
}
